<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="FMH" id="_idParaDest-2">Historian’s Note</p>
<hr class="hr"/>
<p class="FMOT">The main portion of <span class="Italic">Shield of the Gods</span> takes place in April 2385, shortly after <span class="Italic">Star Trek: Department of Temporal Investigations—Time Lock</span> and approximately four months before the dedication of the new Deep Space 9 in <span class="Italic">Star Trek: The Fall—Revelation and Dust</span>.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// historiansnote.vue?ad6e132a